// extracted by mini-css-extract-plugin
module.exports = {"mdx":"legal-rerfesh_mdx__WVGpz"};